import React from "react";
import { siteData } from "../mock";
import SignupForm from "./SignupForm";
import SignupSuccess from "./SignupSuccess";
import { useSignupForm } from "../hooks/useSignupForm";

const Hero = () => {
  const { hero } = siteData;
  const { form, submitting, handleChange, submit, lastResult, clearSuccess } =
    useSignupForm({
      source: "hero",
      successMessage: "Welcome. We're glad you're here.",
    });

  const handleSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  return (
    <section
      id="top"
      className="relative isolate overflow-hidden text-white"
      style={{
        backgroundImage: `url(${hero.heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 ht-hero-overlay" />
      <div className="absolute inset-0 ht-grain opacity-60" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-24 lg:pt-40 lg:pb-32">
        <div className="max-w-4xl mx-auto text-center">
          <p className="ht-fade-up ht-body text-[13px] uppercase tracking-[0.22em] text-[#cfe7f8]/90">
            {hero.eyebrow}
          </p>
          <h1 className="ht-fade-up ht-delay-1 mt-5 ht-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            <span className="text-[#cfe7f8]">{hero.titleStart}</span>{" "}
            <span className="text-white">{hero.titleEnd}</span>
          </h1>
          <p className="ht-fade-up ht-delay-2 mt-6 ht-body text-base sm:text-lg text-white/80 leading-relaxed max-w-3xl mx-auto">
            {hero.subtitle}
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          {/* Birds illustration card */}
          <div className="ht-fade-up ht-delay-3 relative mx-auto w-full max-w-md">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10">
              <img
                src={hero.birdsImg}
                alt="Birds resting together on a branch"
                className="w-full h-[360px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-[#3d4e62]/30 via-transparent to-[#3d4e62]/40" />
              <div className="absolute top-6 left-1/2 -translate-x-1/2">
                <span className="inline-block px-4 py-1.5 rounded-full bg-[#cfe7f8] text-[#2c3e50] text-xs font-semibold tracking-wide">
                  {hero.badgeText}
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-10 text-center">
                <h3 className="ht-display text-white text-3xl drop-shadow-md">
                  {hero.badgeTitle}
                </h3>
              </div>
            </div>
          </div>

          {/* Sign-up form card */}
          <div
            id="join"
            className="ht-fade-up ht-delay-4 ht-card bg-white text-[#2c3e50] rounded-2xl p-7 sm:p-9 shadow-2xl"
          >
            {lastResult ? (
              <SignupSuccess
                firstName={lastResult.firstName}
                alreadyMember={lastResult.alreadyMember}
                onSignAnother={clearSuccess}
                variant="light"
              />
            ) : (
              <>
                <h2 className="ht-display text-2xl sm:text-3xl leading-tight">
                  {hero.cardTitle}
                </h2>
                <p className="mt-2 ht-body text-sm text-[#5a6b7d]">
                  {hero.cardSubtitle}
                </p>

                <SignupForm
                  form={form}
                  submitting={submitting}
                  onChange={handleChange}
                  onSubmit={handleSubmit}
                  ctaLabel={hero.cta}
                  inputVariant="light"
                  className="mt-6"
                />

                <p className="mt-4 text-xs text-[#7e8a96] text-center">
                  {hero.disclaimer}
                </p>
              </>
            )}
          </div>
        </div>

        <p className="ht-fade-up ht-delay-4 mt-12 text-center text-[#cfe7f8]/90 text-sm tracking-wide">
          A small, growing Singapore community. Come as you are.
        </p>
      </div>
    </section>
  );
};

export default Hero;
